// Profil-Nachbau F-15 Punkt 6 (output/profil-team-20261014/BAU-GELD.md 1.6, Teil „Mitglied (Einstieg aus dem Warnhinweis)“,
// wörtlich; PF-759): die Wörter von „Mehr Kontingent anfragen …“ für Mitglieder – der Knopf in der Sperrkarte der Recherche und unter
// dem persönlichen Balken ab 80 %, der Dialog mit der Begründung. Rein, ohne JSX. „Mandantendaten“ meint die Daten der Klientschaft
// einer Kanzlei (wie F-09). Kein Betrag.

export const MEHR_ANFRAGE_TEXTE = {
  knopf: 'Mehr Kontingent anfragen …',
  titel: 'Mehr Kontingent anfragen',
  satz: (firma: string | null | undefined) =>
    `Ihre Kontingent-Anfrage geht an die Verwaltung ${firma ? `von ${firma}` : 'Ihrer Firma'}. Sie bekommen eine Nachricht, sobald sie entschieden ist.`,
  feld: 'Begründung (optional)',
  platzhalter: 'Zum Beispiel: Ich bereite diese Woche drei Verhandlungen vor.',
  hinweis: 'Bitte keine Mandantendaten eintragen.',
  zaehler: (n: number) => `${n} / 500`,
  abbrechen: 'Abbrechen',
  // F-23 (Standard F-23-rahmen-2): „Kontingent-Anfrage“, wo das Wort allein stünde; „Anfrage senden“ ist der Knopf des Supports.
  senden: 'Kontingent-Anfrage senden',
  gesendet: 'Ihre Kontingent-Anfrage ist gesendet.',
  offen: (datum: string) => `Ihre Kontingent-Anfrage vom ${datum} ist noch offen. Eine neue Begründung ersetzt die bisherige.`,
  aktualisieren: 'Kontingent-Anfrage aktualisieren',
  aktualisiert: 'Ihre Kontingent-Anfrage ist aktualisiert.',
} as const;

const TAG = new Intl.DateTimeFormat('de-AT', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Vienna' });
/** „TT.MM.JJJJ“ in Wien. */
export const anfrageDatum = (iso: string) => TAG.format(new Date(iso));
/** Der Einstieg unter dem persönlichen Balken: nur ab 80 % (Zustand FAST oder ERREICHT). */
export const balkenMitAnfrage = (zustand: string | null | undefined) => zustand === 'FAST' || zustand === 'ERREICHT';
/** Anzahlbalken bleiben Alttarifen vorbehalten; ein Paket ohne Nenner ist keine Anzahlgrenze. */
export const kontingentInRecherchen = (organisation: { paket?: boolean; kosten: unknown; recherchen?: unknown; mitKontingent?: boolean } | null | undefined) =>
  !!organisation && !organisation.paket && !organisation.kosten && !!organisation.recherchen && organisation.mitKontingent === true;
/** Der Einstieg in der Sperrkarte: nur bei COST_LIMIT oder (beim Paket, B1-P2-1) RESEARCH_LIMIT mit Grund PERSON oder FIRMA
 *  (nicht TEAM, GUTHABEN, OBERGRENZE). */
export const sperreMitAnfrage = (status: string | null | undefined, grund: string | null | undefined) =>
  (status === 'COST_LIMIT' || status === 'RESEARCH_LIMIT') && (grund === 'PERSON' || grund === 'FIRMA');
